import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EnvironmentService } from "./environment.service";
import { PaginationRequest } from "./models/pagination/pagination.request.model";
import { RequestHelper } from "@shared/helpers/request.helper";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class LeadCampaignApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) {}

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/lead-campaigns`;
    }

    getLeadCampaigns(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.get<any>(this.url, { params: options });
    }

    getAllLeadCampaigns(): Observable<any> {
        return this.httpClient.get<any>(`${this.url}/all`);
    }

    createLeadCampaign(campaign: any): Observable<any> {
        return this.httpClient.post<any>(this.url, campaign);
    }

    updateLeadCampaign(campaign: any): Observable<any> {
        return this.httpClient.put<any>(this.url, campaign);
    }

    deleteLeadCampaign(id: string): Observable<any> {
        return this.httpClient.delete<any>(`${this.url}/${id}`);
    }

    getLeadCampaignById(id: string): Observable<any> {
        return this.httpClient.get<any>(`${this.url}/${id}`);
    }

    getOptions(req: PaginationRequest, body?: any): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        if (body) {
            return this.httpClient.post<any>(`${this.url}/options`, body, { params: options });
        }
        return this.httpClient.get<any>(`${this.url}/options`, { params: options });
    }
}

